// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_7a-3";
export var contentContainer = "_7a-0";
export var editorContainer = "_7a-1";
export var quillInputForm = "_7a-2";
export var zoneDivider = "_7a-4";